import React, { useState, useEffect } from "react";
import "../institute.css";
import Wmbutton from "../../ui-components/wm-button/Wm.button";
import { updateNotice, getNotice } from "../../functions/apis";
import { connect } from "react-redux";
import EventsSearch from "../events/EventsSearch";
import WmModals from "../../modals/Wm.Modals";
import { createNotice, deleteNotice } from '../../functions/apis'
import Table from 'react-bootstrap/Table'
import Spinner from '../../Components/spinner/Spinner'
import moment from 'moment'

function Noticies({ rootData }) {
    const [notice, setNotice] = useState([])
    const [wordCount, setWordCount] = useState(0);
    const [countBool, setCountBool] = useState(false);
    const [noticeText, setNoticeText] = useState('')
    const [noticeLink, setNoticeLink] = useState('')
    const [dateTime, setDataTime] = useState('')
    const [noticeDeleted, setNoticeDeleted] = useState(false)
    const [noticeCreated, setNoticeCreated] = useState(false)
    const [noticeUpdated, setNoticeUpdated] = useState(false)
    const [isFetchingNotice, setIsFetchingNotice] = useState(false)
    const bioWordCount = (e) => {
        setWordCount(e.target.value.length);
        var maxLength = 150;
        if (e.target.value.length >= maxLength) {
            setCountBool(true);
        }
        if (e.target.value.length < maxLength) {
            setCountBool(false);
        }
    };
    useEffect(() => {
        setIsFetchingNotice(true)
        getNotice(rootData.userData.profile_data.username, 'EDIT')
            .then(function (res) {
                setNotice(res.data)
                setIsFetchingNotice(false)
            })
            .catch(function (err) {
                console.log(err)
                setIsFetchingNotice(false)
            })
    }, [noticeDeleted, noticeCreated, noticeUpdated])

    const [noticeSearch, setNoticeSearch] = useState('')
    const [noticeAddModal, setNoticeModal] = useState(false)
    const [noticeEditModal, setNoticeEditModal] = useState(false)
    const [isNoticeCreateing, setIsNoticeCreating] = useState(false)
    const [selectedID, setSelectedID] = useState('')
    const handleCreateNotice = (e) => {
        setIsNoticeCreating(true)
        e.preventDefault();
        createNotice(noticeText, noticeLink, dateTime)
            .then(function (res) {
                setIsNoticeCreating(false)
                setNoticeModal(false)
                setNoticeText('')
                setNoticeLink('')
                setDataTime('')
                setWordCount(0)
                setNoticeCreated(!noticeCreated)
            })
            .catch(function (err) {
                console.log(err)
                setIsNoticeCreating(false)
            })
    }
    const [editNoticeData, setEditNoticeData] = useState({ contentEdit: '', linkEdit: '', endDateEdit: '' })
    const getSingleNoticesData = (id) => {
        // console.log(moment(notice[id].end_date).format('YYYY/MM/DD'))
        console.log(moment.unix(notice[id].end_date).format('yyyy-MM-ddThh:mm'))
        setNoticeEditModal(true)
        setEditNoticeData({
            contentEdit: notice[id].content,
            linkEdit: notice[id].link,
            endDateEdit: notice[id].end_date
        })
    }
    const [isNoticeUpdating, setNoticeUpdating] = useState(false)
    const handleEditNotice = (e) => {
        e.preventDefault();
        setNoticeUpdating(true)
        updateNotice(selectedID, editNoticeData.contentEdit, editNoticeData.linkEdit, editNoticeData.endDateEdit)
            .then((res) => {
                setNoticeUpdating(false)
                setNoticeUpdated(!noticeUpdated)
                setNoticeEditModal(false)
            })
            .catch((err) => {
                console.log(err)
                setNoticeUpdating(false)
            })
    }
    const [deleteNoticeModal, setDeleteNoticeModal] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const handleDeleteNotice = (noticeID) => {
        setIsDeleting(true)
        setDeleteNoticeModal(true)
        deleteNotice(noticeID)
            .then(res => {
                if (res.message === 'Notice Deleted') {
                    setDeleteNoticeModal(false)
                    setNoticeDeleted(!noticeDeleted)
                    setIsDeleting(false)
                }
            })
            .catch(err => {
                console.log(err)
                setIsDeleting(true)
            })
    }
    return (
        <>
            <div className="mb-10 md:mb-0">
                <div className="">
                    <div className="flex space-x-5">
                        <div className="flex-grow">
                            <EventsSearch className=" ring-1 ring-gray-400 px-3 py-2" inputClass="w-full pl-2 placeholder:italic placeholder:text-gray-400" value={noticeSearch} onSearch={(e) => setNoticeSearch(e.target.value)}/>
                        </div>
                        <div className="">
                            <Wmbutton label={"Add Notice"} className="w-full rounded-3xl px-4" type="button" color="primary" onClick={() => setNoticeModal(true)}/>
                        </div>
                    </div>
                    {isFetchingNotice ? <div className='relative w-full mt-7 flex items-center justify-center'>
                        <Spinner className="" width={50} height={50} />
                    </div> : notice.length > 0 ? <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative w-100 mt-10">
                        <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                            <thead>
                                <tr className="text-left">
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                        Sr.no
                                    </th>
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs w-80">
                                        Notice
                                    </th>
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                        Notice Link
                                    </th>
                                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {notice.filter((x) => x["content"].toLowerCase().includes(noticeSearch.toLowerCase())).map((data, idx) => {
                                    return <tr key={idx} className="cursor-pointer">
                                        <td className="border-dashed border-t border-gray-200 userId">
                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">{idx + 1}</span>
                                        </td>
                                        <td className="border-dashed border-t border-gray-200 firstName">
                                            <p className="text-gray-700 mx-6 my-3 flex items-center text-sm  overflow-hidden wordClamp-1" title={data.content}>{data.content}</p>
                                        </td>
                                        <td className="border-dashed border-t border-gray-200 lastName">
                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                                                <div>
                                                    {data.link ? <a href={data.link}>click to preview</a> : '-'}
                                                </div>
                                            </span>
                                        </td>
                                        <td className="border-dashed border-t border-gray-200 emailAddress">
                                            <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                                                <div className='text-center flex space-x-3'>
                                                    <button onClick={() => { getSingleNoticesData(idx); setSelectedID(data.id) }} className='px-4 py-1 bg-gray-300 rounded'>
                                                        Edit
                                                    </button>
                                                    <button onClick={() => { setDeleteNoticeModal(true); setSelectedID(data.id) }} className='px-4 py-1 bg-red-500 rounded text-white'>
                                                        Delete
                                                    </button>
                                                </div>
                                            </span>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div> : <div className="col-md-12 mt-5">
                        <span className="block manpro text-xl font-semibold text-center">OOPS!! No Notice Found</span>
                    </div>}
                </div>
            </div>
            <WmModals show={noticeAddModal} onHide={() => setNoticeModal(false)} size="lg" className="edu-modal">
                <h5 className="mb-4">Add Notice</h5>
                <form>
                    <div className="wm_form_group flex flex-col mb-4">
                        <label className="wm_form_label">Notice</label>
                        <textarea
                            name="description"
                            className="wm_form_input border-bottom border-gray-300"
                            value={noticeText}
                            onChange={(e) => setNoticeText(e.target.value)}
                            onKeyUp={(e) => bioWordCount(e)}
                            maxLength="150"
                            required
                        ></textarea>
                        <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>
                            {wordCount}/150
                        </small>
                    </div>
                    <div className="col-md-6 px-0">
                        <div className="wm_form_group flex flex-col mb-4">
                            <label className="wm_form_label">End date</label>
                            <input type="datetime-local" id="datetime" className="wm_form_input border-bottom border-gray-300" value={dateTime} onChange={(e) => setDataTime(e.target.value)} />
                        </div>
                    </div>
                    <div className="wm_form_group flex flex-col mb-4">
                        <label className="wm_form_label">Notice Link</label>
                        <input
                            type="url"
                            name="institute"
                            className="wm_form_input border-bottom border-gray-300"
                            onChange={(e) => setNoticeLink(e.target.value)}
                            value={noticeLink}
                        />
                        <small className='manpro text-gray-600'>Please type in the correct URL for the Publication http://example.com/</small>
                    </div>
                    <div className="wm_form_group flex">
                        {!isNoticeCreateing && <Wmbutton
                            label="Save"
                            bordered
                            className="rounded w-20 mr-2"
                            type="submit"
                            color="primary-border"
                            onClick={(e) => handleCreateNotice(e)}
                        />}

                        {isNoticeCreateing && <div className='relative w-20 flex items-center justify-center'>
                            <Spinner className="" width={27} height={27} />
                        </div>}
                        <Wmbutton
                            label="Cancel"
                            onClick={() => { setNoticeModal(false) }}
                            className="rounded w-20"
                            type="button"
                            color="primary"
                        />
                    </div>
                </form>
            </WmModals>
            <WmModals show={noticeEditModal} onHide={() => setNoticeEditModal(false)} size="lg" className="edu-modal">
                <h5 className="mb-4">Edit Notice</h5>
                <form>
                    <div className="wm_form_group flex flex-col mb-4">
                        <label className="wm_form_label">Notice</label>
                        <textarea
                            name="description"
                            className="wm_form_input border-bottom border-gray-300"
                            value={editNoticeData.contentEdit}
                            onChange={(e) => setEditNoticeData({ ...editNoticeData, contentEdit: e.target.value })}
                            onKeyUp={(e) => bioWordCount(e)}
                            maxLength="150"
                            required
                        ></textarea>
                        <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>
                            {wordCount}/150
                        </small>
                    </div>
                    <div className="col-md-6 px-0">
                        <div className="wm_form_group flex flex-col mb-4">
                            <label className="wm_form_label">End date</label>
                            <input type="datetime-local" id="datetime" className="wm_form_input border-bottom border-gray-300" value={moment.unix(editNoticeData.endDateEdit).format('yyyy-MM-DDThh:mm')} onChange={(e) => setEditNoticeData({ ...editNoticeData, endDateEdit: e.target.value })} />
                        </div>
                    </div>
                    <div className="wm_form_group flex flex-col mb-4">
                        <label className="wm_form_label">Notice Link</label>
                        <input
                            type="url"
                            name="institute"
                            className="wm_form_input border-bottom border-gray-300"
                            onChange={(e) => setEditNoticeData({ ...editNoticeData, linkEdit: e.target.value })}
                            value={editNoticeData.linkEdit}
                        />
                        <small className='manpro text-gray-600'>Please type in the correct URL for the Publication http://example.com/</small>
                    </div>
                    <div className="wm_form_group flex">
                        {!isNoticeUpdating && <Wmbutton
                            label="Save"
                            bordered
                            className="rounded w-20 mr-2"
                            type="submit"
                            color="primary-border"
                            onClick={(e) => handleEditNotice(e)}
                        />}
                        {isNoticeUpdating && <div className='relative w-20 flex items-center justify-center'>
                            <Spinner className="" width={27} height={27} />
                        </div>}
                        <Wmbutton
                            label="Cancel"
                            onClick={(e) => { setNoticeEditModal(false) }}
                            className="rounded w-20 mr-2"
                            type="button"
                            color="primary"
                        />
                    </div>
                </form>
            </WmModals>
            <WmModals show={deleteNoticeModal} onHide={() => setDeleteNoticeModal(false)} size="md" className="">
                <div className="px-3 py-3">
                    <h5 className="mb-4 text-red-600">Danger zone ⚠️</h5>
                    <form>
                        <div className='mb-3'>
                            <span>
                                Are you sure you want to delete this notice
                            </span>
                        </div>
                        <div className="wm_form_group flex">
                            {!isDeleting && <Wmbutton
                                label="Delete"
                                onClick={(e) => { handleDeleteNotice(selectedID) }}
                                className="rounded w-20 mr-2"
                                type="button"
                                color="danger"
                            />}
                            {isDeleting && <div className='relative w-20 flex items-center justify-center'>
                                <Spinner className="" width={27} height={27} />
                            </div>}
                            <Wmbutton
                                label="Cancel"
                                onClick={(e) => { setDeleteNoticeModal(false) }}
                                className="rounded w-20"
                                type="button"
                                color="primary"
                            />
                        </div>
                    </form>
                </div>
            </WmModals>
        </>
    );
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps, null)(Noticies);
